import React, { useEffect, useRef, useState } from 'react';
import { ListGroup, Card, Form } from 'react-bootstrap';
const ModelInstanceSelector = _ref => {
  var _selectedInstances$;
  let {
    className = '',
    allowMultipleSelection,
    selectInstances,
    isAllSelected,
    setIsAllSelected,
    onSearch,
    // must return an object in the form { values: [], totalPages: Integer (optional) }
    alreadySelectedInstances,
    displayTextKey,
    searchInputRef
  } = _ref;
  const [isMultipleSelectionEnabled, setIsMultipleSelectionEnabled] = useState(false);
  const [filteredInstances, setFilteredInstances] = useState([]);
  const [selectedInstances, setSelectedInstances] = useState(alreadySelectedInstances || []);
  const latestSearchRequestIndex = useRef(0);
  const searchTimeout = useRef(null);
  useEffect(() => {
    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, []);
  const searchInstances = async searchValue => {
    const searchRequestIndex = ++latestSearchRequestIndex.current;
    if (!searchValue) {
      setFilteredInstances([]);
      return;
    }
    const result = await onSearch(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase());
    if (searchRequestIndex !== latestSearchRequestIndex.current) {
      return;
    }
    const filteredInstances = result.values;
    const pages = result.pages;
    setFilteredInstances(filteredInstances);
  };
  const searchInstancesWithDebounce = e => {
    const searchValue = e.target.value;
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
    if (!searchValue) {
      latestSearchRequestIndex.current += 1;
      setFilteredInstances([]);
      return;
    }
    searchTimeout.current = setTimeout(() => {
      searchTimeout.current = null;
      searchInstances(searchValue);
    }, 500);
  };
  const MultipleSelectionToggle = () => {
    return /*#__PURE__*/React.createElement("span", {
      className: "material-icons mt-1 dashboard-business-unit-multiple-select \n      ".concat(isMultipleSelectionEnabled ? 'dashboard-business-unit-multiple-select__active' : 'dashboard-business-unit-multiple-select__inactive'),
      onClick: () => setIsMultipleSelectionEnabled(!isMultipleSelectionEnabled),
      "data-testid": "model-instance-selector-multiple-selection-toggle"
    }, "checklist_rtl");
  };
  const AllSelectionToggle = () => {
    return /*#__PURE__*/React.createElement(ListGroup.Item, {
      className: "busines-unit-item mb-1",
      active: isAllSelected,
      key: "all",
      action: true,
      onClick: () => setIsAllSelected(!isAllSelected),
      "data-testid": "model-instance-selector-all-selection-toggle"
    }, "All");
  };
  const renderInstances = () => {
    return filteredInstances.map(filteredInstance => {
      if (filteredInstance.id === undefined || filteredInstance.id === null) {
        console.warn('ModelInstanceSelector: instance does not have an id', filteredInstance);
      }
      const displayText = filteredInstance[displayTextKey];
      if (displayText === undefined || displayText === null) {
        console.warn("ModelInstanceSelector: displayTextKey \"".concat(displayTextKey, "\" does not exist on instance"), filteredInstance);
      }
      return /*#__PURE__*/React.createElement(ListGroup.Item, {
        className: "busines-unit-item mb-1",
        active: selectedInstances.findIndex(i => i.id === filteredInstance.id) > -1,
        key: filteredInstance.id,
        "data-testid": "model-instance-selector-item-".concat(filteredInstance.id),
        action: true,
        onClick: e => {
          e.preventDefault();
          selectInstances(filteredInstance);
        }
      }, displayText);
    });
  };
  return /*#__PURE__*/React.createElement(Card, {
    "data-testid": "model-instance-selector",
    className: "p-2 model-instance-selector-card ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    className: "dashboard-business-unit-search mb-2 me-2",
    placeholder: "Search",
    "data-testid": "model-instance-selector-search-input",
    onChange: searchInstancesWithDebounce,
    ref: searchInputRef
  }), allowMultipleSelection && /*#__PURE__*/React.createElement(MultipleSelectionToggle, null)), /*#__PURE__*/React.createElement(ListGroup, {
    defaultActiveKey: (_selectedInstances$ = selectedInstances[0]) === null || _selectedInstances$ === void 0 ? void 0 : _selectedInstances$.id
  }, allowMultipleSelection && /*#__PURE__*/React.createElement(AllSelectionToggle, null), renderInstances()));
};
export default ModelInstanceSelector;